import Hoodmaintenances from './hood_maintenances.vue';
import Hoodaddmaintenance from './hood_add_maintenance.vue'
import HoodsDetailTablePanel from './hoods-detail-table-panel.vue'

export default{
  Hoodmaintenances,
  Hoodaddmaintenance,
  'hoods-detail-table-panel': HoodsDetailTablePanel,
}